// Library methods
import { useTranslation } from "react-i18next";

// Components
import { Box, Divider, Grid, Typography } from "@mui/material";

const EyeAlignmentResults = ({ eyeAlignmentResults, getFormattedResponse }) => {
  // internationalization
  const { t } = useTranslation();

  return (
    <Box
      border="1px solid black"
      borderRadius="8px"
      p="20px"
      sx={{ width: "100%", height: "100%" }}
    >
      <Typography mb="20px">{t("word_eye_alignment_results")}</Typography>
      <Grid item xs={12} display="flex" flexDirection="column" gap="20px">
        <Grid item xs={12} display="flex" justifyContent="space-around">
          <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            gap="4px"
          >
            <Typography fontWeight={600} fontSize="14px">
              {t("phoria_type")}
            </Typography>
            <Typography fontSize="14px">
              {t(`word_${eyeAlignmentResults?.[0]?.phoriaType?.toLowerCase()}`)}
            </Typography>
          </Box>

          <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            gap="4px"
          >
            <Typography fontWeight={600} fontSize="14px">
              {t("tropia_type")}
            </Typography>
            <Typography fontSize="14px">
              {t(`word_${eyeAlignmentResults?.[0]?.tropiaType?.toLowerCase()}`)}
            </Typography>
          </Box>

          <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            gap="4px"
          >
            <Typography fontWeight={600} fontSize="14px">
              {t("suppression_type")}
            </Typography>
            <Typography fontSize="14px">
              {t(
                `word_${eyeAlignmentResults?.[0]?.suppressionType?.toLowerCase()}`
              )}
            </Typography>
          </Box>
        </Grid>

        <Divider />

        <Grid item xs={12} display="flex" flexDirection="column">
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-around"
            gap="20px"
          >
            {eyeAlignmentResults?.[1]?.responses?.map((response, index) => {
              const isCorrect =
                response.responseData === response.expectedResponse;
              return (
                <Box
                  key={response.questionType}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  textAlign="center"
                  gap="4px"
                >
                  <Typography fontWeight={600} fontSize="14px">
                    {index + 1}. {t(response.questionType)}
                  </Typography>
                  <Typography fontSize="14px">
                    {`${t("word_response")}: ${getFormattedResponse(response.responseData)}`}
                  </Typography>
                  {response.expectedResponse && (
                    <Typography
                      fontSize="14px"
                      color={isCorrect ? "#13A321" : "#B21515"}
                    >
                      {`${t("word_expected_response")}: ${getFormattedResponse(response.expectedResponse)}`}
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EyeAlignmentResults;
